import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Banner from "../../HomeScreens/Components/Banner";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const CustomerChangePassword = () => {
    const { rest_name } = useParams();
    const navigate = useNavigate();
    const [showModalReg, setShowModalReg] = useState(false);
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showCurrentPassword, setShowCurrentPassword] = useState(true);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleSave = async () => {
        try {
            setIsLoading(true);
            const token = localStorage.getItem("token");
            const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;

            const passResponse = await axios.post(
                `${apiUrl}/api/v1/change-password`,
                {
                    current_password: currentPassword,
                    new_password: newPassword,
                    new_password_confirmation: confirmPassword,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (passResponse.data?.message) {
                toast.success(passResponse.data.message, {
                    theme: "colored",
                    autoClose: 1000,
                });
                navigate(`/restaurant/${rest_name}`);
            }
        } catch (error) {
            const responseData = error?.response?.data;

            if (responseData?.error) {
                toast.error(responseData.error, { theme: "colored", autoClose: 1000 });
            } else if (responseData?.errors) {
                const errors = responseData.errors;

                Object.keys(errors).forEach((key) => {
                    errors[key].forEach((message) => {
                        toast.error(message, { theme: "colored", autoClose: 1000 });
                    });
                });
            } else {
                toast.error(
                    responseData?.message || "Something went wrong.",
                    { theme: "colored", autoClose: 1000 }
                );
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="flex flex-col w-full h-[100vh] overflow-y-scroll">
                <Banner
                    showModalReg={showModalReg}
                    setShowModalReg={setShowModalReg}
                />
                <section className="border-t border-[#D9D9D9] pt-[15px]">
                    <div className="max-w-[800px] m-auto px-0 mx-auto mt-[12px] mb-[50px]">
                        <h3 className="sm:text-[28px] text-[25px] sm:leading-[37px] leading-[35px] font-bold mb-[24px] poppins-medium text-center ">Cambiare la password</h3>
                        <div className="w-full h-auto bg-[#FCFCFC] text-left text-red-700 space-y-5 border-[2px] border-[#8B24332B] sm:p-10 p-5 rounded-xl shadow-md font-sans">
                            <div className="mb-6">
                                <label className="text-lg mt-2 mb-2 sm:mb-3 sm:mt-3 block font-semibold poppins-medium text-[#6B6B6B]">
                                    Password attuale:
                                </label>
                                <div className="relative w-full">
                                    <input
                                        type={showCurrentPassword ? "text" : "password"}
                                        className="poppins-regular w-full px-4 py-[18px] rounded-[28px] text-xs text-[#8B8B8B]   bg-transparent border border-[#777777] focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                        value={currentPassword?.trim() || ""}
                                        onChange={(e) => setCurrentPassword(e.target.value)}
                                    />
                                    <button
                                        type="button"
                                        className="absolute top-1/2 right-4 text-gray-400 hover:text-gray-600 transform -translate-y-1/2"
                                        onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                                    >
                                        {showCurrentPassword ? <FaEyeSlash /> : <FaEye />}
                                    </button>
                                </div>
                                <label className="text-lg mt-2 mb-2 sm:mb-3 sm:mt-3 block font-semibold poppins-medium text-[#6B6B6B]">
                                    Nuova Password:
                                </label>
                                <div className="relative w-full">
                                    <input
                                        type={showNewPassword ? "text" : "password"}
                                        className="poppins-regular w-full px-4 py-[18px] rounded-[28px] text-xs text-[#8B8B8B]   bg-transparent border border-[#777777] focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                        value={newPassword?.trim() || ""}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                    />
                                    <button
                                        type="button"
                                        className="absolute top-1/2 right-4 text-gray-400 hover:text-gray-600 transform -translate-y-1/2"
                                        onClick={() => setShowNewPassword(!showNewPassword)}
                                    >
                                        {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                                    </button>
                                </div>
                                <label className="text-lg  mt-2 mb-2 sm:mb-3 sm:mt-3 block font-semibold poppins-medium text-[#6B6B6B]">
                                    Conferma Password:
                                </label>
                                <div className="relative w-full">
                                    <input
                                        type={showConfirmPassword ? "text" : "password"}
                                        className="poppins-regular w-full px-4 py-[18px] rounded-[28px] text-xs text-[#8B8B8B]   bg-transparent border border-[#777777] focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                                        value={confirmPassword?.trim() || ""}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                    />
                                    <button
                                        type="button"
                                        className="absolute top-1/2 right-4 text-gray-400 hover:text-gray-600 transform -translate-y-1/2"
                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    >
                                        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                    </button>
                                </div>
                            </div>
                            <div className="flex text-sm sm:flex-row flex-col justify-start gap-4 mt-10">
                                {isLoading ? (
                                    <button disabled type="button"
                                        className="max-w-[100%] sm:max-w-[200px] w-full h-[54px] poppins-regular justify-center flex items-center space-x-2 p-1 px-3 bg-[#8A2533] text-white border-[1.5px] border-[#d18d97] rounded-[28px] transition-colors group">
                                        <svg
                                            aria-hidden="true"
                                            className="w-4 h-4 text-gray-50 me-3 animate-spin dark:text-gray-600 fill-[#8B2433] invert"
                                            viewBox="0 0 100 101"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                fill="currentColor"
                                            />
                                            <path
                                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                fill="currentFill"
                                            />
                                        </svg>
                                        Loading...
                                    </button>
                                ) : (
                                    <button className="max-w-[100%] sm:max-w-[200px] w-full justify-center flex items-center space-x-2 p-1 px-3 py-[16px] bg-[#8B2433] text-white border-[1.5px] border-[#d18d97]  rounded-[28px] hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
                                        onClick={handleSave}
                                    >
                                        <span className="poppins-regular">UPDATE PASSWORD</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default CustomerChangePassword;